module.exports = __webpack_public_path__ + "img/line-logo.f9ff3e51.svg";